import { images } from "./Assets/assetsHelper";

// Code Develop
// const config = {
//   API_BASE_URL: "https://stagingscoringapi.codechallenge-championship.org",
//   REG_LINK: "https://codechallenge-championship.org/firstStage",
//   APP_ENV: "develop",
//   APP_NAME: "Code Reg",
//   DEFAULT_LANGUAGE: "en",
//   PRIMARY_COLOR: "#6a0505",
//   SECONDARY_COLOR: "#fff",
//   APP_LOGO: images.Company_Logo_Hor,
// };

// Code Production
const config = {
  API_BASE_URL: "https://scoringapi.codechallenge-championship.org",
  REG_LINK: "https://codechallenge-championship.org/firstStage",
  APP_ENV: "production",
  APP_NAME: "Code Reg",
  DEFAULT_LANGUAGE: "en",
  PRIMARY_COLOR: "#6a0505",
  SECONDARY_COLOR: "#fff",
  APP_LOGO: images.Company_Logo_Hor,
};

export default config;
